var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[(_vm.$store.state.valorLogo === true)?_c('div',{staticClass:"d-flex flex-column justify-space-between align-center"},[_c('v-img',{attrs:{"src":"assets/banner.png","max-width":"250"},on:{"click":function($event){_vm.$router.push(
        { path: '/data' },
        function () {
          _vm.$emit('reload')
        }
      )}}})],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }